import { render, staticRenderFns } from "./S3Video.vue?vue&type=template&id=08f17168&scoped=true&"
import script from "./S3Video.vue?vue&type=script&lang=ts&"
export * from "./S3Video.vue?vue&type=script&lang=ts&"
import style0 from "./S3Video.vue?vue&type=style&index=0&id=08f17168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f17168",
  null
  
)

export default component.exports